import api from './api';
import { LageplanAnsicht, GeoJsonImportErgebnis, StammdatenImportErgebnis } from '../types';

export const lageplanService = {
  // Read-only view data: graves with georeferenced geometry and status.
  getAnsicht: async (friedhofId: number): Promise<LageplanAnsicht> => {
    const response = await api.get(`/friedhoefe/${friedhofId}/lageplan/ansicht`);
    return response.data;
  },

  // Import grave geometry from a GeoJSON FeatureCollection (merge by abteilung + grabnummer).
  importGeoJson: async (friedhofId: number, featureCollection: unknown): Promise<GeoJsonImportErgebnis> => {
    const response = await api.post(`/friedhoefe/${friedhofId}/lageplan/geojson`, featureCollection);
    return response.data;
  },

  // Bulk import grave occupancy + buried animals from a transcribed ledger (JSON { zeilen: [...] }).
  importStammdaten: async (friedhofId: number, payload: unknown): Promise<StammdatenImportErgebnis> => {
    const response = await api.post(`/friedhoefe/${friedhofId}/datenimport`, payload);
    return response.data;
  },

  // Save the admin-configured per-section colors (map main section -> hex).
  saveAbteilungFarben: async (friedhofId: number, farben: Record<string, string>): Promise<Record<string, string>> => {
    const response = await api.put(`/friedhoefe/${friedhofId}/abteilung-farben`, farben);
    return response.data;
  },

  // Save the admin-configured default base map (LUFTBILD | KARTE | WEISS | SATELLIT).
  saveLageplanHintergrund: async (friedhofId: number, hintergrund: string): Promise<string> => {
    const response = await api.put(`/friedhoefe/${friedhofId}/lageplan-hintergrund`, { hintergrund });
    return response.data.hintergrund;
  }
};

export default lageplanService;
